import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-061c42c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "codeInput",
  class: "form-label"
}, "Sign in code", -1))
const _hoisted_3 = ["readonly"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "other-actions" }

import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useSignInStore } from './SignInStore'
import { useAppHostStore } from '@webapp/AppHostStore'
import { useUserStore } from '@webapp/gp/UserStore'
import { getSafeRedirectUri, usePageTitle } from '@webapp/util/AppUtil'
import { useIdentityApi } from '@webapp/auth/IdentityApi'
import { useTokenManager } from './TokenManager'
import { ApiError, PatchChange } from '@webapp/util/Api'
import TaskPage from '@webapp/util/TaskPage.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SignInCodePage',
  props: {
    noRedirect: { type: Boolean }
  },
  emits: [
  'authenticated'
],
  setup(__props: any, { emit }) {

const props = __props;





usePageTitle("Sign in")

const identityApi = useIdentityApi()
const tokenManager = useTokenManager()
const router = useRouter()
const appHostStore = useAppHostStore()
const isEmbeddedRef = computed(() => appHostStore.isEmbedded)
const signInStore = useSignInStore()
const userStore = useUserStore()

const codeRef = ref("")
const busyRef = ref(false)

const canSignInRef = computed(() => codeRef.value.length > 5)
const retryPageRef = computed(() => signInStore.isNewUser ? "/signup" : "/signin")

const codeInputRef = ref<HTMLInputElement>()

async function signIn(e: Event) {
  e.preventDefault()

  if (signInStore.address) {
    busyRef.value = true

    let token = null
    try {
      const response = await identityApi.signInAsync(signInStore.address, codeRef.value)
      token = response.access_token
    }
    catch (ex) {
      if (ex instanceof ApiError && ex.statusCode != 400) {
        // TODO: notify/track unexpected error
      }
      // TODO: notify user of invalid code
      busyRef.value = false
      return
    }

    // SECURITY: set window location (instead of using router) to force app state to reset (new user -> new state)
    if (appHostStore.isEmbedded && !props.noRedirect) {
      // give host a chance to grab the access token (doesn't work for iframe "hosts")
      window.location.href = "/authredirect?access_token=" + encodeURIComponent(token)
    }
    else {
      await tokenManager.exchangeToken(token)

      if (props.noRedirect) {
        emit('authenticated')
      }
      else {
        window.location.href = getSafeRedirectUri() ?? "/home"
      }
    }
  }
}

onMounted(() => {
  if (tokenManager.current.isValid) {
    router.replace('/home')
  }
  else {
    codeInputRef.value!.focus()
    codeInputRef.value!.select()
  }
})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(TaskPage, {
    class: _normalizeClass(["signin-code-page", { embedded: isEmbeddedRef.value }]),
    "no-title": isEmbeddedRef.value,
    "no-back": "",
    "no-action": ""
  }, {
    title: _withCtx(() => [
      _createTextVNode("Sign in")
    ]),
    instruction: _withCtx(() => [
      _createTextVNode(" Check your email and enter the code we sent you. ")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _hoisted_2,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control code-input",
            id: "codeInput",
            ref_key: "codeInputRef",
            ref: codeInputRef,
            readonly: busyRef.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((codeRef).value = $event))
          }, null, 8, _hoisted_3), [
            [_vModelText, codeRef.value]
          ])
        ]),
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-primary",
          disabled: !canSignInRef.value,
          onClick: signIn
        }, "Sign in", 8, _hoisted_4),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, { to: retryPageRef.value }, {
            default: _withCtx(() => [
              _createTextVNode("Use a different email address")
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["no-title", "class"]))
}
}

})